// Layout.jsx - Modern ChatGPT-Inspired Layout
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";
import { verifyData } from "../../pages/Common/CommonFunctions/commonFunctions";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

import { FiAlertTriangle, FiUpload, FiX } from "react-icons/fi";
import ChatWidget from "../../pages/Chat/ChatWidget";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      sidebarCollapsed: false,
      sidebarHovered: false,
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
    this.handleSidebarHover = this.handleSidebarHover.bind(this);
    this.handleSidebarLeave = this.handleSidebarLeave.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    // Set page title
    let currentPage = this.capitalizeFirstLetter(this.props.location.pathname);
    document.title = currentPage + " | HireNeuron";

    // Apply ChatGPT theme settings
    this.props.changeSidebarTheme("dark");
    this.props.changeTopbarTheme("dark");
    this.props.changeLayout("detached");

    if (window.innerWidth > 992) {
      if (this.props.layoutWidth) {
        this.props.changeLayoutWidth(this.props.layoutWidth);
      }
      if (this.props.leftSideBarType) {
        this.props.changeSidebarType(this.props.leftSideBarType);
      }
    }

    // Handle responsive behavior
    if (window.innerWidth <= 768) {
      this.setState({ sidebarCollapsed: true });
    }
  }

  componentDidUpdate(prevProps) {
    // Update title when route changes
    if (prevProps.location.pathname !== this.props.location.pathname) {
      let currentPage = this.capitalizeFirstLetter(
        this.props.location.pathname,
      );
      document.title = currentPage + " | HireNeuron";
      window.scrollTo(0, 0);
    }
  }

  toggleMenuCallback = () => {
    this.setState({ sidebarCollapsed: false, sidebarHovered: false });
  };

  handleSidebarHover = () => {
    if (this.state.sidebarCollapsed && window.innerWidth > 768) {
      this.setState({ sidebarHovered: true });
    }
  };

  handleSidebarLeave = () => {
    if (this.state.sidebarCollapsed && window.innerWidth > 768) {
      this.setState({ sidebarHovered: false });
    }
  };

  render() {
    const data = JSON.parse(localStorage.getItem("authUser"));
    const { sidebarCollapsed, sidebarHovered, isMobile } = this.state;

    const handleImpersonateMode = () => {
      let companyId = JSON.parse(localStorage.getItem("authUser")).companyId;
      localStorage.removeItem("authUser");
      if (
        localStorage.getItem("secondaryStorage") != null &&
        localStorage.getItem("secondaryStorage") !== undefined
      ) {
        localStorage.setItem(
          "authUser",
          localStorage.getItem("secondaryStorage"),
        );
        localStorage.removeItem("secondaryStorage");
      } else {
        localStorage.removeItem("isAuthProtected");
      }
      localStorage.removeItem("impersonationMode");
      window.location =
        process.env.REACT_APP_Admin_UI + `admin/company/${companyId}`;
      localStorage.setItem("reloadMessage", "reload");
    };

    return (
      <React.Fragment>
        <div
          id="layout-wrapper"
          className="chatgpt-layout"
          onClick={this.handleOverlayClick}
        >
          {/* Impersonation Mode Banner */}
          {localStorage.getItem("impersonationMode") !== undefined &&
          localStorage.getItem("impersonationMode") !== null ? (
            <div className="chatgpt-banner impersonation-banner">
              <div className="banner-content">
                <FiAlertTriangle className="banner-icon" size={16} />
                <span>You are in Impersonation mode.</span>
                <button
                  onClick={handleImpersonateMode}
                  className="banner-action-btn"
                >
                  End Session
                </button>
              </div>
            </div>
          ) : null}

          {/* Header */}
          <Header toggleMenuCallback={this.toggleMenuCallback} />

          {/* Sidebar */}
          <Sidebar
            theme={this.props.leftSideBarTheme}
            type={this.props.leftSideBarType}
            isMobile={this.state.isMobile}
            collapsed={sidebarCollapsed}
            hovered={sidebarHovered}
          />

          {/* Main Content Area */}
          <div
            className="main-content sidebar-expanded"
          >
            {/* Content Container */}
            <div className="content-container">{this.props.children}</div>



            {/* Footer */}
            <Footer />
          </div>
          <ChatWidget />
        </div>
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  topbarTheme: PropTypes.any,
};

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout));
